// assets
import { IconCalendarBolt } from '@tabler/icons-react';

// constant
const icons = {
  IconCalendarBolt
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  title: 'Events',
  caption: 'Event Calendar',
  type: 'group',
  children: [
    {
      id: 'calendar',
      title: 'Calendar',
      type: 'item',
      icon: icons.IconCalendarBolt,
      url: '/year-calendar',
    }
  ]
};

export default pages;
